(function () {
  'use strict';

  var PROPERTY_KEY = '_cover_gift';
  var isSyncing = false;
  var syncTimer = null;
  var tagCache = {};

  function parseConfig(el) {
    if (!el || el.dataset.enabled !== 'true') return null;
    var t1 = parseInt(el.getAttribute('data-threshold-1'), 10);
    var t2 = parseInt(el.getAttribute('data-threshold-2'), 10);
    return {
      tag:        (el.dataset.coverTag || 'button-cover').toLowerCase().trim(),
      threshold1: isNaN(t1) ? 6 : t1,
      variantId1: el.getAttribute('data-variant-id-1') || '',
      threshold2: isNaN(t2) ? 9 : t2,
      variantId2: el.getAttribute('data-variant-id-2') || '',
    };
  }

  function getConfig() {
    var pageEl = document.getElementById('cover-gift-config-page');
    if (pageEl) return parseConfig(pageEl);
    return parseConfig(document.getElementById('cover-gift-config'));
  }

  function getProductHandle(item) {
    if (item.handle) return item.handle;
    var m = (item.url || '').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function fetchProductTags(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var raw = product.tags || '';
        var tags = (typeof raw === 'string' ? raw : raw.join(','))
          .split(',')
          .map(function (t) { return t.trim().toLowerCase(); })
          .filter(Boolean);
        tagCache[handle] = tags;
        return tags;
      })
      .catch(function () { return []; });
  }

  function computeCoverCount(cartItems, coverTag) {
    var handles = cartItems
      .map(getProductHandle)
      .filter(function (h, i, arr) { return h && arr.indexOf(h) === i; });

    return Promise.all(handles.map(fetchProductTags)).then(function () {
      var count = 0;
      cartItems.forEach(function (item) {
        var handle = getProductHandle(item);
        var tags = (handle && tagCache[handle]) || [];
        if (tags.indexOf(coverTag) !== -1) count += item.quantity;
      });
      return count;
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Returns full section objects { id, selector? } — mirrors Dawn's getSectionsToRender()
  function cartSections() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      return cartItems.getSectionsToRender();
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender();
    }
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  function cartSectionIds() {
    return cartSections().map(function (s) { return s.id; });
  }

  function addGift(variantId, thresholdKey) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { [PROPERTY_KEY]: thresholdKey } }],
        sections: cartSectionIds(),
      }),
    }).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error('add gift failed: ' + t); });
      return r.json();
    });
  }

  function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: cartSectionIds() }),
    }).then(function (r) {
      if (!r.ok) throw new Error('remove gift failed');
      return r.json();
    });
  }

  function findGiftItem(items, variantId, thresholdKey) {
    if (!variantId) return null;
    return items.find(function (item) {
      return (
        item.variant_id.toString() === variantId &&
        item.properties &&
        item.properties[PROPERTY_KEY] === thresholdKey
      );
    }) || null;
  }

  // Updates DOM using the same selector pattern as Dawn's renderContents()
  function renderSections(data) {
    if (!data || !data.sections) return;
    cartSections().forEach(function (section) {
      var html = data.sections[section.id];
      if (!html) return;
      var selector = section.selector || '.shopify-section';
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var sourceEl = parsed.querySelector(selector);
      var targetEl = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (targetEl && sourceEl) targetEl.innerHTML = sourceEl.innerHTML;
    });
  }

  function syncGifts() {
    if (isSyncing) return;

    var config = getConfig();
    if (!config) return;

    isSyncing = true;

    fetchCart()
      .then(function (cart) {
        return computeCoverCount(cart.items, config.tag).then(function (coverCount) {
          var needsGift1 = !!config.variantId1 && coverCount >= config.threshold1;
          var needsGift2 = !!config.variantId2 && coverCount >= config.threshold2;
          var giftItem1  = findGiftItem(cart.items, config.variantId1, 'threshold_1');

          var op1 = Promise.resolve(null);
          if (needsGift1 && !giftItem1) {
            op1 = addGift(config.variantId1, 'threshold_1');
          } else if (!needsGift1 && giftItem1) {
            op1 = removeGift(giftItem1.key);
          }

          return op1.then(function (response1) {
            return fetchCart().then(function (freshCart) {
              var giftItem2 = findGiftItem(freshCart.items, config.variantId2, 'threshold_2');

              var op2 = Promise.resolve(null);
              if (needsGift2 && !giftItem2) {
                op2 = addGift(config.variantId2, 'threshold_2');
              } else if (!needsGift2 && giftItem2) {
                op2 = removeGift(giftItem2.key);
              }

              return op2.then(function (response2) {
                renderSections(response2 || response1);
              });
            });
          });
        });
      })
      .catch(function () {})
      .then(function () { isSyncing = false; });
  }

  function scheduleSyncGifts() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGifts, 300);
  }

  function watchElement(el, subtree) {
    if (!el) return;
    new MutationObserver(scheduleSyncGifts).observe(el, { childList: true, subtree: !!subtree });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncGifts();
    watchElement(document.getElementById('CartDrawer'), true);
    watchElement(document.querySelector('#main-cart-items .js-contents'), false);
  });
})();
